import mutations from './mutations'
import actions from './actions'

const state = {
  all_autos: [],
  autos: [],  // Add this line - similar to destinations
  auto: [],
  errors: []
}

export default {
  state,
  mutations,
  actions
}